import { Typography, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { GameInfoView } from "./GameInfoView";
import { persistLocalStateToCloud } from "../utils/playerState";
import { DialogControl } from "../controls/DialogControl";

export interface InfoDialogProps {
  onClose: (b: boolean) => void;
}
export function GameInfoDialog(props: InfoDialogProps) {
  const { onClose } = props;
  const [open, setOpen] = React.useState(true);
  const { t } = useTranslation();

  const handleClose = () => {
    localStorage.setItem("hideInfo", "true");
    void persistLocalStateToCloud();
    setOpen(false);
    onClose(true);
  };

  return (
    <DialogControl
      open={open}
      onClose={handleClose}
      title={
        <Typography
          flexGrow={1}
          variant="h5"
          textAlign={"center"}
          fontWeight={600}
        >
          {t("gameInfoDialogTitle")}
        </Typography>
      }
      actions={
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleClose}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {t("dontShowAgainButton")}
        </Button>
      }
    >
      <GameInfoView title="" />
    </DialogControl>
  );
}
